/**
 * API utilities and axios instances
 * Extracted from App.js for better maintainability
 */
import axios from 'axios';

// Smart backend URL detection - handles production, preview, and native Capacitor
const PRODUCTION_URL = 'https://www.blkpacks.fun';
const getBackendUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'www.blkpacks.fun' || hostname === 'blkpacks.fun') return window.location.origin;
    if (hostname.includes('emergentagent.com')) return window.location.origin;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      const envUrl = process.env.REACT_APP_BACKEND_URL;
      if (!envUrl || envUrl.includes('emergentagent.com') || envUrl.includes('preview.')) return PRODUCTION_URL;
      return envUrl;
    }
  }
  return process.env.REACT_APP_BACKEND_URL || PRODUCTION_URL;
};

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;

/**
 * Convert an upload URL to use CDN if available.
 * Handles: /api/uploads/file.png -> CDN_URL/uploads/file.png
 * Also handles full backend URLs and already-CDN URLs.
 */
export const cdnUrl = (url) => {
  const CDN = process.env.REACT_APP_CDN_URL || '';
  if (!url || !CDN) return url;
  if (url.startsWith(CDN)) return url;
  if (url.startsWith('/api/uploads/')) {
    return `${CDN}/${url.replace('/api/uploads/', 'uploads/')}`;
  }
  if (url.includes('/api/uploads/')) {
    const path = url.split('/api/uploads/')[1];
    return `${CDN}/uploads/${path}`;
  }
  return url;
};

/**
 * Create an authenticated axios instance
 * @param {string} token - JWT token
 * @returns {AxiosInstance} - Configured axios instance
 */
export const authApi = (token) => axios.create({
  baseURL: API,
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
});

/**
 * Public axios instance (no auth required)
 */
export const publicApi = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default {
  BACKEND_URL,
  API,
  authApi,
  publicApi
};
